module.exports = __webpack_public_path__ + "img/slide_02.81965654.jpg";